<template>
    <div class="d-flex flex-column">
        <div v-if="$root.$data.transaction.hasOwnProperty('canDisplayItemDetails') && $root.$data.transaction.canDisplayItemDetails">
            <div class="d-flex align-items-center justify-content-between">
                <span class="font-sm font-weight-bold text-capitalize text-gray-dk">Payment Summary</span>
                <img alt="" v-if="dropdown" src="/img/hcpay/chevron.svg" class="dropdownIcon img-responsive clickable" :class="{ 'dropdownShown' : dropdownShown}" @click="dropdownShown = !dropdownShown" data-bs-toggle="collapse" data-bs-target="#paymentSummaryCollapse" :aria-expanded="dropdownShown" aria-controls="paymentSummaryCollapse">
            </div>
            <div class="collapse show" id="paymentSummaryCollapse">
                <div v-for="product in $root.$data.transaction.products" :key="product.key" class="d-flex align-items-start my-4">
                    <div class="col-6 col-xl-8 d-flex p-0">
                        <span class="font-sm productName">{{ product.name }}</span>
                        <span class="font-sm ml-1 mr-auto align-self-end">x{{product.quantity}}</span>
                    </div>
                    <div class="col"></div>
                    <div class="font-sm d-block col-5 col-xl-3 p-0 text-right">₱ {{ toCurrency(product.itemPrice) }}</div>
                </div>
                <hr />
                <div class="d-flex justify-content-between mt-4">
                    <span class="font-sm text-capitalize">Subtotal</span>
                    <span class="font-sm text-capitalize">₱ {{ toCurrency(this.$root.$data.transaction.subtotal) }}</span>
                </div>
                <div class="d-flex justify-content-between mt-4">
                    <span class="font-sm text-capitalize" data-toggle="tooltip" data-placement="right" title="Total of other fees and discounts from the merchant (ex. shipping fee, store promo)">
                        Miscellaneous
                        <img alt="" src="/img/hcpay/information-icon.svg" class="accountTypeIcon img-responsive ml-1">
                    </span>
                    <span class="font-sm text-capitalize">₱ {{ toCurrency(this.$root.$data.transaction.totalMiscFee) }}</span>
                </div>
                <div class="d-flex justify-content-between mt-4">
                    <span class="font-sm text-capitalize" data-toggle="tooltip" data-placement="right" title="A discount to your purchase for using Home Credit Pay">
                        Home Credit Discount
                        <img alt="" src="/img/hcpay/information-icon.svg" class="accountTypeIcon img-responsive ml-1">
                    </span>
                    <span class="font-sm text-capitalize">₱ 0.00</span>
                </div>
                <hr/>
                <div v-if="$root.$data.transaction.paymentOption === 'hc_loan'" class="d-flex justify-content-between mt-4">
                    <span class="font-sm font-weight-bold text-capitalize text-gray-dk">Finance Amount</span>
                    <span class="font-md font-weight-bold text-capitalize text-gray-dk">₱ {{ toCurrency(this.$root.$data.transaction.installmentDetails.financedAmount) }}</span>
                </div>
                <div v-else class="d-flex justify-content-between mt-4">
                    <span class="font-sm font-weight-bold text-capitalize text-gray-dk">Total Amount</span>
                    <span class="font-md font-weight-bold text-capitalize text-gray-dk">₱ {{ toCurrency(this.$root.$data.transaction.amount) }}</span>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="d-flex justify-content-between mt-4">
                <span class="font-sm font-weight-bold text-capitalize text-gray-dk">Total Amount</span>
                <span class="font-md font-weight-bold text-capitalize text-gray-dk">₱ {{ toCurrency(this.$root.$data.transaction.amount) }}</span>
            </div>
        </div>
    </div>
</template>
<script>
$(function(){
  $('[data-toggle="tooltip"]').tooltip({
    placement: 'right'
  });
});
export default {
    props: {
        dropdown: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            dropdownShown : true,
            finalTotla: 0.00,
            productSum: 0.00
        }
    },
    methods: {
        toCurrency(value) {

            // Check if the value is NaN or empty (null, undefined, or other falsy values)
            if (!value || isNaN(value)) {
                value = 0;
            }

            let val = (value/1).toFixed(2).replace(',', '.')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },
        getTotal() {
            return this.toCurrency(this.$root.$data.products.reduce((total,product) => total + product.amount,0));
        }
    }
}
</script>
<style scoped>
    .dropdownIcon {
        height: auto;
        width: 0.8rem;
        transition-duration: 0.5s;
    }
    .dropdownShown {
        transform:rotate(-180deg);
    }
</style>